import AccountDetailsView from "./AccountDetailsView"
export default AccountDetailsView
